package com.sweetlime.bingeamigo.presentation.features.auth

import androidx.compose.material3.OutlinedTextFieldDefaults
import androidx.compose.runtime.Composable
import androidx.compose.ui.graphics.Color
import cafe.adriel.voyager.core.screen.Screen
import com.sweetlime.bingeamigo.presentation.ui.BrandColors
import cafe.adriel.voyager.navigator.LocalNavigator
import cafe.adriel.voyager.navigator.currentOrThrow
import com.sweetlime.bingeamigo.presentation.navigation.MainScreen

class AuthScreen : Screen {

    @Composable
    override fun Content() {

        val navigator =
            LocalNavigator.currentOrThrow

        AuthContent(
            onAuthSuccess = {
                navigator.replace(MainScreen)
            },
            onPendingVerification = { email ->
                navigator.replace(EmailVerificationScreen(email))
            },
            authTextFieldColors = { authTextFieldColors() }
        )
    }
}

@Composable
fun authTextFieldColors() =
    OutlinedTextFieldDefaults.colors(

        focusedContainerColor =
            Color(0xFF1E1E1E),

        unfocusedContainerColor =
            Color(0xFF1E1E1E),

        focusedBorderColor =
            BrandColors.Primary,

        unfocusedBorderColor =
            Color.Transparent,

        focusedTextColor =
            Color.White,

        unfocusedTextColor =
            Color.White,

        focusedPlaceholderColor =
            Color.Gray,

        unfocusedPlaceholderColor =
            Color.Gray,

        focusedLeadingIconColor =
            BrandColors.Primary,

        unfocusedLeadingIconColor =
            Color.Gray
    )